const getExtension = filename => {
  return filename.split('.').pop();
};

export default getExtension;
